import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CollapsePanel from '../CollapsePanel/CollapsePanel';
import Text from '../BuildingBlocks/Text';
import VerticalSpacing from '../Utility/VerticalSpacing/VerticalSpacing';
import Adaptive from '../Adaptive/Adaptive';
import RichText from '../RichText';
import IgnoreTranslation from '../Localize/ignoreTranslation';

class PDPContent extends Component {
  static propTypes = {
    /** Lodge/Hotel location */
    location: PropTypes.string.isRequired,
    /** Lodge/Hotel name */
    name: PropTypes.string.isRequired,
    /** String of HTML content to be sent through RichText parser */
    description: PropTypes.string.isRequired,
    /** Panel open text */
    openText: PropTypes.string,
    /** Panel close text */
    closeText: PropTypes.string
  };

  static defaultProps = {
    openText: 'See More',
    closeText: 'See Less'
  };

  constructor(props) {
    super(props);

    this.renderMobileLayout = this.renderMobileLayout.bind(this);
  }

  static renderRichText(richTextContent) {
    const convertedText = (
      <RichText
        whitelist={['p', 'strong']}
        converters={{
          p: {
            element: Text.CopyBody,
            props: { tagName: 'p', color: 'primary' }
          },
          strong: {
            element: Text.CopyBody,
            props: { tagName: 'span', color: 'primary', weight: 'bold' }
          }
        }}
        content={richTextContent}
      />
    );

    return convertedText;
  }

  renderMobileLayout() {
    const { openText, closeText, description } = this.props;

    // Split the paragraphs into array items
    const paragraphs = description.split('</p>');
    paragraphs.pop();

    // Grab the first one to show initially on its own
    const [visible] = paragraphs;

    // Grab the rest that we want to show in the collapse panel, join the together so we can put them through RichText all at once
    const hidden = paragraphs.slice(1, paragraphs.length);
    const hiddenContent = hidden.join(' ');

    const mobileLayout = (
      <div>
        {PDPContent.renderRichText(visible)}
        {hidden.length > 0 && (
          <CollapsePanel openText={openText} closeText={closeText}>
            {PDPContent.renderRichText(hiddenContent)}
          </CollapsePanel>
        )}
      </div>
    );

    return mobileLayout;
  }

  render() {
    const { location, name, description } = this.props;

    return (
      <VerticalSpacing size="sm">
        <Text.HeadingFifth tagName="h2" color="quaternary" textTransform="uppercase">
          {location}
        </Text.HeadingFifth>
        <IgnoreTranslation>
          <Text.HeadingThird tagName="h1">{name}</Text.HeadingThird>
        </IgnoreTranslation>

        <Adaptive sm={this.renderMobileLayout()} lg={PDPContent.renderRichText(description)} />
      </VerticalSpacing>
    );
  }
}

export default PDPContent;
